export class FormatIdentifier {
  constructor(
    public id: number,
    public originalId: number,
    public masterCode: string,
    public originalLayerId: number,
    public name: string,
    public reportTypeId: number,
  ) {
  }
}
